import loadable from "@loadable/component";
import ProductListSkeleton from "../components/Results/ProductListSkeleton";

const CategoryPageRoute = loadable(
  () =>
    import(
      /* webpackPreload: true, webpackChunkName: "CATEGORY_PAGE" */ "../pages/CategoryPage"
    ),
  {
    fallback: <ProductListSkeleton />
  }
);

export default CategoryPageRoute;
